<template>
  <div>
    <div class="country-hat">
      <active-button
        class="country-button"
        @click="/* $router.push(`/prematch/sport/${sport}/country/${country.id}`) */"
      >
        <country-icon
          :code="country.code"
          :name="country['name_' + $i18n.locale]"
        ></country-icon>
        <div
          class="country-name ellipsis"
          :title="country['name_' + $i18n.locale]"
        >
          {{ $i18n.locale ? country['name_' + $i18n.locale] : country.name }}
        </div>
      </active-button>
      <!--icon-button @click="open = !open">
        <arrow-icon :direction="open ? 'up' : 'down'"></arrow-icon>
      </icon-button-->
    </div>
    <div class="list" :class="open ? 'open' : ''">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import ActiveButton from '@/components/buttons/ActiveButton'
import IconButton from '@/components/buttons/IconButton'
import ArrowIcon from '@/components/icons/ArrowIcon'
import CountryIcon from '@/components/icons/CountryIcon'

export default {
  components: {
    ActiveButton,
    IconButton,
    ArrowIcon,
    CountryIcon
  },
  props: {
    country: Object,
    sport: Number
  },
  data () {
    return {
      open: true
    }
  }
}
</script>

<style scoped>
.country-hat { display: flex; height: 40px; line-height: 40px; background: rgba(117,80,118,.1) !important; border-radius: 10px; margin-right: 10px; margin-top: 1px; }
.country-hat:not(first-child) { margin-top: 3px; }
.country-hat .arrow-icon { font-size: 20px; }
.country-button { display: flex; cursor: default; }
.country-button:hover { background: none; }
.country-name { width: calc(100% - 40px); }
.list { display: none; }
.list.open { display: block; }
</style>



// WEBPACK FOOTER //
// src/components/sports/main_sport_2/Country.vue